import { AlertTriangle, CheckCircle2 } from "lucide-react";

// Compact "Paid To: Employee — Name" line with a green/red bank-status marker.
// Account numbers are never shown here, only whether the details are complete.
export function PayeeCell({ line }) {
  const bank = line.payee_bank_complete;
  return (
    <div className="text-xs" data-testid={`payee-cell-${line.id}`}>
      <span className="text-slate-500">Paid To: </span>
      <span data-testid={`payee-type-${line.id}`}>{line.payee_type}</span>
      {line.payee_name ? <span> — {line.payee_name}</span> : null}
      {bank === true && (
        <span className="flex items-center gap-1 text-[10px] text-emerald-600 mt-0.5" data-testid={`payee-bank-ok-${line.id}`}>
          <CheckCircle2 className="h-3 w-3" /> Bank details complete
        </span>
      )}
      {bank === false && (
        <span className="flex items-center gap-1 text-[10px] text-red-600 mt-0.5" data-testid={`payee-bank-warning-${line.id}`}>
          <AlertTriangle className="h-3 w-3" /> Bank details incomplete
        </span>
      )}
    </div>
  );
}
